/**
 * WARNING: This file is auto-generated. Please do not modify it.
 *
 * If you need to make changes, please see the README.md file in the root of this repository.
 */

import { AxiosRequestConfig, AxiosResponse } from 'axios';

import { Controller } from '../Controller';

import {
  GetV2GuestPrototypesShareReviewByShareTokenParams,
  PostV2GuestPrototypesShareReviewByShareTokenParams,
  PostV2GuestPrototypesShareReviewEventsByShareTokenAndReviewIdParams,
  PostV2GuestPrototypesShareReviewFinishByShareTokenParams,
  PostV2GuestPrototypesShareAiReviewByShareTokenParams,
  PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdParams,
  PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdParams,
  GetV2GuestPrototypesShareByShareTokenParams,
  GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdParams,
  GetV2GuestPrototypesSharePartialsByShareTokenAndPartialIdParams,
  GetV2GuestPrototypesSharePagesByShareTokenAndPageIdParams,
  GetV2GuestPrototypesShareAiReviewsByShareTokenParams,
  GetV2GuestPrototypesShareAiReviewsByShareTokenAndReviewIdParams,
  GetV2GuestPrototypesShareAiReviewsWorkspaceByShareTokenParams,
  GetV2GuestPrototypesShareAiReviewPagesChatByShareTokenAndReviewIdParams,
  GetV2GuestPrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdParams,
  GetV2GuestPrototypesShareAiExtendedReviewsByShareTokenAndReviewIdParams,
  GetV2GuestPrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdParams,
  GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdQuery,
  PostV2GuestPrototypesShareReviewEventsByShareTokenAndReviewIdBody,
  PostV2GuestPrototypesShareReviewFinishByShareTokenBody,
  PostV2GuestPrototypesShareAiReviewByShareTokenBody,
  PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdBody,
  PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdBody,
  GetV2GuestPrototypesShareReviewByShareTokenResponse,
  PostV2GuestPrototypesShareReviewByShareTokenResponse,
  PostV2GuestPrototypesShareReviewFinishByShareTokenResponse,
  PostV2GuestPrototypesShareAiReviewByShareTokenResponse,
  PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdResponse,
  PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdResponse,
  GetV2GuestPrototypesShareByShareTokenResponse,
  GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdResponse,
  GetV2GuestPrototypesSharePartialsByShareTokenAndPartialIdResponse,
  GetV2GuestPrototypesSharePagesByShareTokenAndPageIdResponse,
  GetV2GuestPrototypesShareAiReviewsByShareTokenResponse,
  GetV2GuestPrototypesShareAiReviewsByShareTokenAndReviewIdResponse,
  GetV2GuestPrototypesShareAiReviewsWorkspaceByShareTokenResponse,
  GetV2GuestPrototypesShareAiReviewPagesChatByShareTokenAndReviewIdResponse,
  GetV2GuestPrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdResponse,
  GetV2GuestPrototypesShareAiExtendedReviewsByShareTokenAndReviewIdResponse,
  GetV2GuestPrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdResponse,
} from '../types';

export class GuestPrototypesShare extends Controller {
  async getV2GuestPrototypesShareReviewByShareToken<
    T extends GetV2GuestPrototypesShareReviewByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2GuestPrototypesShareReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/review`,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareReviewByShareToken<
    T extends PostV2GuestPrototypesShareReviewByShareTokenResponse,
    D,
    C extends null
  >(
    body: C,
    { shareToken }: PostV2GuestPrototypesShareReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/review`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareReviewEventsByShareTokenAndReviewId<
    T,
    D,
    C extends PostV2GuestPrototypesShareReviewEventsByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2GuestPrototypesShareReviewEventsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/review/${reviewId}/events`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareReviewFinishByShareToken<
    T extends PostV2GuestPrototypesShareReviewFinishByShareTokenResponse,
    D,
    C extends PostV2GuestPrototypesShareReviewFinishByShareTokenBody
  >(
    body: C,
    { shareToken }: PostV2GuestPrototypesShareReviewFinishByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/review/finish`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareAiReviewByShareToken<
    T extends PostV2GuestPrototypesShareAiReviewByShareTokenResponse,
    D,
    C extends PostV2GuestPrototypesShareAiReviewByShareTokenBody
  >(
    body: C,
    { shareToken }: PostV2GuestPrototypesShareAiReviewByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/review`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageId<
    T extends PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdResponse,
    D,
    C extends PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
      pageId,
      messageId,
    }: PostV2GuestPrototypesShareAiReviewPagesMessagesSystemResponseByShareTokenAndReviewIdAndPageIdAndMessageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/review/${reviewId}/pages/${pageId}/messages/${messageId}/system/response`,
      body,
      axiosConfig
    );
  }

  async postV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewId<
    T extends PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdResponse,
    D,
    C extends PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdBody
  >(
    body: C,
    {
      shareToken,
      reviewId,
    }: PostV2GuestPrototypesShareAiReviewFinishByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.post<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/review/${reviewId}/finish`,
      body,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareByShareToken<
    T extends GetV2GuestPrototypesShareByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2GuestPrototypesShareByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewId<
    T extends GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdParams,
    query: GetV2GuestPrototypesShareReviewsEventsByShareTokenAndReviewIdQuery,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      this.composeUrl(
        `/v2/guest/prototypes/share/${shareToken}/reviews/${reviewId}/events`,
        query
      ),
      axiosConfig
    );
  }

  async getV2GuestPrototypesSharePartialsByShareTokenAndPartialId<
    T extends GetV2GuestPrototypesSharePartialsByShareTokenAndPartialIdResponse,
    D,
    C
  >(
    {
      shareToken,
      partialId,
    }: GetV2GuestPrototypesSharePartialsByShareTokenAndPartialIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/partials/${partialId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesSharePagesByShareTokenAndPageId<
    T extends GetV2GuestPrototypesSharePagesByShareTokenAndPageIdResponse,
    D,
    C
  >(
    {
      shareToken,
      pageId,
    }: GetV2GuestPrototypesSharePagesByShareTokenAndPageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/pages/${pageId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiReviewsByShareToken<
    T extends GetV2GuestPrototypesShareAiReviewsByShareTokenResponse,
    D,
    C
  >(
    { shareToken }: GetV2GuestPrototypesShareAiReviewsByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/reviews`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiReviewsByShareTokenAndReviewId<
    T extends GetV2GuestPrototypesShareAiReviewsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2GuestPrototypesShareAiReviewsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/reviews/${reviewId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiReviewsWorkspaceByShareToken<
    T extends GetV2GuestPrototypesShareAiReviewsWorkspaceByShareTokenResponse,
    D,
    C
  >(
    {
      shareToken,
    }: GetV2GuestPrototypesShareAiReviewsWorkspaceByShareTokenParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/reviews/workspace`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiReviewPagesChatByShareTokenAndReviewId<
    T extends GetV2GuestPrototypesShareAiReviewPagesChatByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2GuestPrototypesShareAiReviewPagesChatByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/review/${reviewId}/pages/chat`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadId<
    T extends GetV2GuestPrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdResponse,
    D,
    C
  >(
    {
      shareToken,
      pageId,
      pageThreadId,
    }: GetV2GuestPrototypesShareAiReviewPagesThreadChatByShareTokenAndPageIdAndPageThreadIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/review/pages/${pageId}/thread/${pageThreadId}/chat`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiExtendedReviewsByShareTokenAndReviewId<
    T extends GetV2GuestPrototypesShareAiExtendedReviewsByShareTokenAndReviewIdResponse,
    D,
    C
  >(
    {
      shareToken,
      reviewId,
    }: GetV2GuestPrototypesShareAiExtendedReviewsByShareTokenAndReviewIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/extended/reviews/${reviewId}`,
      axiosConfig
    );
  }

  async getV2GuestPrototypesShareAiChatMessagesConversationByShareTokenAndMessageId<
    T extends GetV2GuestPrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdResponse,
    D,
    C
  >(
    {
      shareToken,
      messageId,
    }: GetV2GuestPrototypesShareAiChatMessagesConversationByShareTokenAndMessageIdParams,
    axiosConfig?: AxiosRequestConfig<C> | undefined
  ): Promise<AxiosResponse<T, D>> {
    return await this.axios.get<T, AxiosResponse<T, D>, C>(
      `/v2/guest/prototypes/share/${shareToken}/ai/chat/messages/${messageId}/conversation`,
      axiosConfig
    );
  }
}
